module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-runtime/~/core-js/library/modules/$.library.js
 ** module id = 35
 ** module chunks = 0
 **/